export enum TrackEvent {
  AUDIO_LISTENED_SECONDS = 'audio_listened_seconds',
  AUDIO_PLAYED = 'audio_played',
  DOWNLOAD = 'download',
  EMBEDDABLE_VIEWED_SECONDS = 'embeddable_viewed_seconds',
  IMAGES_VIEWED_SECONDS = 'image_viewed_seconds',
  PAGE_TRACKERS = 'page_trackers',
  TEXT_READ_SECONDS = 'text_read_seconds',
  URL_CLICKED = 'url_clicked',
  URL_VIEWED_SECONDS = 'url_viewed_seconds',
  VIDEO_PLAYED = 'video_played',
  VIDEO_PLAYED_SECONDS = 'video_played_seconds',
  VIEW = 'view',
}

/**
 * Events that are actually significant for the user. They represent actual
 * user interactions, instead of "unconscious" actions such as "viewing"
 * a content which represents a piece of content that entered the user's
 * viewport. These events are used to calculate the percentage of
 * viewed content and completion rate.
 */
export const SIGNIFICANT_EVENTS = [
  TrackEvent.AUDIO_LISTENED_SECONDS,
  TrackEvent.EMBEDDABLE_VIEWED_SECONDS,
  TrackEvent.IMAGES_VIEWED_SECONDS,
  TrackEvent.PAGE_TRACKERS,
  TrackEvent.TEXT_READ_SECONDS,
  TrackEvent.URL_CLICKED,
  TrackEvent.URL_VIEWED_SECONDS,
  TrackEvent.VIDEO_PLAYED_SECONDS,
];
